export enum REPORT_FILTER_TYPES {
  BASIC = 1,
  COLUMN = 2,
  ADVANCED = 3,
}

export enum REPORT_FIELD_OUTPUT_TYPES {
  TEXT = 1,
  DATE_TIME = 2,
  DATE = 3,
  TIME = 4,
  COORDINATES = 5,
  NUMBER = 6,
  KPH_TO_SPEED_UNITS = 7, // 0-MPH (MPH), 1-KM/H(KPH), 2-KNOTS(KNOTS)
  KM_TO_DISTANCE_UNITS = 8, // 0-MILES(MILES), 1-KM(KM), 2-NAUTICAL MILES(NAUTICAL MILES)
  M_TO_DISTANCE_UNITS = 9, // 0-MILES(MILES), 1-KM(KM), 2-NAUTICAL MILES(NAUTICAL MILES)
  L_TO_VOLUME_UNITS = 10, // 0-GALLONS(US_GALLONS), 1-LITERS(LITERS), 2-IMPERIAL GALLONS(UK_GALLONS), 3-FT^3(CUBIC_FEET)
  KPL_ECONOMY_UNITS = 11, // 0-MPG(MPG), 1-KM/L(KPL), 2-KPG(KPG), 3-L/100KM(LP100KM)
  KPA_TO_PRESSURE_UNITS = 12, // 0-kPa(KPA), 1-psi(PSI), 2-mmHg(MMHG), 3-bar(BAR)
  C_TO_TEMPERATURE_UNITS = 13, // 0-Fahrenheit(F), 1-Celsius(C)
  SEC_TO_HOURS = 14,
  SEC_TO_HH_MM_SS = 15,
  GREGORIAN_DATE = 53,
  ACTIVE_INACTIVE_DROPDOWN = 54,
  AUDIT_CHANGE_TYPE = 55,
  METER_TO_FEET = 56,
  YES_NO_DROPDOWN = 57,
  NORMAL_DATE = 58,
  NORMAL_TIME = 59,
  WHOLE_NUMBER = 60,
  HEADING_KPH_TO_SPEED_UNITS = 61,
  ASTERISK_KM_TO_DISTANCE_UNITS = 62,
  STATUS_WITH_COLOR = 63, // data expected to be of the form "<display text>|<foreground color hex code>|<background color hex code>"
  RATIO_TO_PERCENT = 71,
  DECI_MT_TO_DISTANCE_UNITS = 72,
  DECI_SEC_TO_HH_MM_SS = 73,
  // Distance per kWh: only the numerator converts, so it follows the distance unit.
  KM_PER_KWH_TO_ECONOMY_UNITS = 75,
  // Seconds shown as "1 hr 42 min"; stored numeric so the column sorts correctly.
  SEC_TO_HR_MIN = 76,
}

export enum REPORT_FIELD_OUTPUT_TYPES_WITH_AGGREGATION {
  NUMBER = 6,
  KPH_TO_SPEED_UNITS = 7,
  KM_TO_DISTANCE_UNITS = 8,
  M_TO_DISTANCE_UNITS = 9,
  L_TO_VOLUME_UNITS = 10,
  KPL_ECONOMY_UNITS = 11,
  KPA_TO_PRESSURE_UNITS = 12,
  C_TO_TEMPERATURE_UNITS = 13,
  SEC_TO_HOURS = 14,
  SEC_TO_HH_MM_SS = 15,
  METER_TO_FEET = 56,
}

export enum REPORT_FIELD_OUTPUT_TYPES_NUMBER_ALIGNMENT {
  NUMBER = 6,
  KPH_TO_SPEED_UNITS = 7, // 0-MPH (MPH), 1-KM/H(KPH), 2-KNOTS(KNOTS)
  KM_TO_DISTANCE_UNITS = 8, // 0-MILES(MILES), 1-KM(KM), 2-NAUTICAL MILES(NAUTICAL MILES)
  M_TO_DISTANCE_UNITS = 9, // 0-MILES(MILES), 1-KM(KM), 2-NAUTICAL MILES(NAUTICAL MILES)
  L_TO_VOLUME_UNITS = 10, // 0-GALLONS(US_GALLONS), 1-LITERS(LITERS), 2-IMPERIAL GALLONS(UK_GALLONS), 3-FT^3(CUBIC_FEET)
  KPL_ECONOMY_UNITS = 11, // 0-MPG(MPG), 1-KM/L(KPL), 2-KPG(KPG), 3-L/100KM(LP100KM)
  KPA_TO_PRESSURE_UNITS = 12, // 0-kPa(KPA), 1-psi(PSI), 2-mmHg(MMHG), 3-bar(BAR)
  C_TO_TEMPERATURE_UNITS = 13, // 0-Fahrenheit(F), 1-Celsius(C)
  METER_TO_FEET = 56,
}

// modify with caution - keys are being used as values and in translation
export enum REPORT_FILTER_OPERATOR_TYPES {
  EQUAL = "=",
  NOT_EQUAL = "<>",
  GREATER_THAN = ">",
  GREATER_THAN_EQUAL = ">=",
  LESS_THAN = "<",
  LESS_THAN_EQUAL = "<=",
  LIKE = "LIKE",
  IN = "IN",
  NOT_IN = "NOT IN",
  GROUP_IN = "GROUP IN",
  NOT_LIKE = "NOT LIKE",
  BETWEEN = "BETWEEN",

  // extra operators - not in BE but used in FE with values same as above - for translation
  BEFORE = "<",
  AFTER = ">",
}

// deprecated
export enum COLUMN_DROPDOWN_TYPES {
  ASSET_ID = "1",
  GROUP_ID = "3",
  //other values to be added
}

export const DOWNLOAD_OPTIONS = [
  { label: "XLS", value: "xlsx" },
  { label: "CSV", value: "csv" },
  { label: "PDF", value: "pdf" },
];

// The download options a report offers; all of them until the report says otherwise.
export const downloadOptionsFor = (downloadFormats?: string[]) =>
  downloadFormats
    ? DOWNLOAD_OPTIONS.filter((item) => downloadFormats.includes(item.value))
    : DOWNLOAD_OPTIONS;

export const FREQUENCY_OPTIONS = [
  "hourly",
  "daily",
  "weekly",
  "monthly",
  "bi_monthly",
];

export const SHARE_OPTIONS = [
  { label: "Internal", value: "internal" },
  { label: "Via Email", value: "email" },
];

export const DAY_OF_WEEK_OPTIONS = [
  { label: "Monday", value: "monday" },
  { label: "Tuesday", value: "tuesday" },
  { label: "Wednesday", value: "wednesday" },
  { label: "Thursday", value: "thursday" },
  { label: "Friday", value: "friday" },
  { label: "Saturday", value: "saturday" },
  { label: "Sunday", value: "sunday" },
];

export const DAY_OF_MONTH_OPTIONS = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8", value: "8" },
  { label: "9", value: "9" },
  { label: "10", value: "10" },
  { label: "11", value: "11" },
  { label: "12", value: "12" },
  { label: "13", value: "13" },
  { label: "14", value: "14" },
  { label: "15", value: "15" },
  { label: "16", value: "16" },
  { label: "17", value: "17" },
  { label: "18", value: "18" },
  { label: "19", value: "19" },
  { label: "20", value: "20" },
  { label: "21", value: "21" },
  { label: "22", value: "22" },
  { label: "23", value: "23" },
  { label: "24", value: "24" },
  { label: "25", value: "25" },
  { label: "26", value: "26" },
  { label: "27", value: "27" },
  { label: "28", value: "28" },
  { label: "29", value: "29" },
  { label: "30", value: "30" },
  { label: "31", value: "31" },
];

export const getDayOfWeekInNumber = (day: string) => {
  switch (day) {
    case "monday":
      return 1;
    case "tuesday":
      return 2;
    case "wednesday":
      return 3;
    case "thursday":
      return 4;
    case "friday":
      return 5;
    case "saturday":
      return 6;
    case "sunday":
      return 7;
    default:
      return 1;
  }
};

export enum REPORT_GROUP_BY_LEVEL {
  GROUP_BY = 1,
  SUB_GROUP_BY = 2,
}

export const REPORT_GROUP_BY_LEVEL_SLUGS = {
  GROUP_BY: `group-by-level-${REPORT_GROUP_BY_LEVEL.GROUP_BY}`,
  SUB_GROUP_BY: `group-by-level-${REPORT_GROUP_BY_LEVEL.SUB_GROUP_BY}`,
};

export const DROPPABLE_ID_PREFIX_REPORT_COLUMN = "report-column-id-";

export const REPORT_ADVANCED_FILTER_PARAM_NAME = "$custom";

export const REPORT_SPECIAL_VALUES = {
  BLANK: {
    FOR_COMPARE: "",
    FOR_API: "BLANK",
    FOR_DISPLAY: "",
  },
  NULL: {
    FOR_COMPARE: null,
    FOR_API: "NULL",
    FOR_DISPLAY: "N/A",
  },
};

// if params have `time_range` filter, then make sure that `start_time` and `end_time` filters have a valid value (it can be current unix timestamp)
// // this is required by the backend
export const STANDARD_REPORT_TIME_RANGE_TIMESTAMP = 1737090000;

// Reports (by standard report identifier; custom copies inherit it) that offer the color mode:
// dark background, colored status badges, and every row in the range in one scrolling list.
export const COLOR_MODE_REPORT_IDENTIFIERS = [
  "EVENT_DETAIL_REPORT",
  "EVENT_DETAIL_(ALL_FIELDS)",
];
// Rows fetched per request while scrolling in color mode.
export const COLOR_MODE_BATCH_SIZE = 500;
